import {useEffect, useState} from "react";

export const HardwareTopBar: React.FC<any> = ({data}) => {
  const [swipesCount, setSwipesCount] = useState({
    totalHardware: 0,
    activeHardware: 0,
    inactiveHardware: 0
  });
  useEffect(() => {
    if (data?.rows.length > 0) {
      let totalHardware = 0;
      let activeHardware = 0;
      let inactiveHardware = 0;
      for (const entry of data.rows) {
        totalHardware += 1;
        activeHardware += entry.status === "Online" ? 1 : 0;
        inactiveHardware += entry.status === "Offline" ? 1 : 0;
      }
      setSwipesCount({
        totalHardware: totalHardware,
        activeHardware: activeHardware,
        inactiveHardware: inactiveHardware
      });
    }
  }, [data?.rows]);
  return (
    <>
      <div className="mb-4 grid grid-cols-1 gap-4 sm:grid-cols-3">
        <div className="rounded-lg bg-gray-100 p-4 shadow">
          <p className="text-sm text-gray-500">Total Hardware</p>
          <p className="text-2xl font-semibold text-gray-800">
            {swipesCount.totalHardware}
          </p>
        </div>
        <div className="rounded-lg bg-green-100 p-4 shadow">
          <p className="text-sm text-green-700">Online</p>
          <p className="text-2xl font-semibold text-green-900">
            {swipesCount.activeHardware}
          </p>
        </div>
        <div className="rounded-lg bg-red-100 p-4 shadow">
          <p className="text-sm text-red-700">Offline</p>
          <p className="text-2xl font-semibold text-red-900">
            {swipesCount.inactiveHardware}
          </p>
        </div>
      </div>
    </>
  );
};
